import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createAuth } from '../Helpers';
import config from '../config';

export const reducerName = 'freeTextState';

export const getFreeText = createAsyncThunk(
    'freeTextState/get',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/freeText`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            console.log('ERROR FETCHING FREETEXT', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    text: [{ id: 0, content: 'loading...', size: 2 }],
    status: 'idle',
    error: null,
};

const freeTextSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFreeText.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getFreeText.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.text = action.payload; 
            })
            .addCase(getFreeText.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default freeTextSlice.reducer;